@if (product && shop) {
  <div class="card card-product" [ngClass]="{ 'card-slider': slider }">
    <div class="row">
      <div class="col-card-background" [ngClass]="[slider ? 'col-12' : 'col-4 col-md-12']">
        <div
          class="card-background"
          [lazyLoad]="product.media?.length > 0 ? product.media[0]?.url1x + '?w=350&h=350&m=2' + addWebp : ''"
        >
          <!-- <div class="card-voucher" *ngIf="product.type === ProductType.Voucher">
          <div class="icon-voucher-container">
            <span class="icon-voucher" [inlineSVG]="'/icons/icon-voucher.svg'"></span>
          </div>
        </div> -->
          @if (product.label || product.instances === ProductInstances.Available) {
            <div class="card-label">
              {{
                this.product.instances === ProductInstances.Available
                  ? ('product.label.sold_out' | transloco)
                  : fromProductLabels(product.label)
                    ? ('product.label.' + product.label | transloco)
                    : product.label
              }}
            </div>
          }
        </div>
      </div>
      <div class="col-body" [ngClass]="[slider ? 'col-12' : 'col-8 col-md-12']">
        <div class="card-body d-flex align-items-start flex-column">
          <div class="card-head w-100">
            <div class="card-title dot mb-0">
              @if (product.type === ProductType.Voucher) {
                <span class="icon-voucher" [inlineSVG]="'/icons/icon-voucher.svg'"></span>
              }
              <span>{{ product.public_name }}</span>
            </div>
            @if (displayShopName) {
              <div class="card-sub-title">
                {{ shop.name }}
              </div>
            } @else {
              @if (product.subtitle) {
                <div class="card-sub-title">
                  {{ product.subtitle }}
                </div>
              }
            }
          </div>
          <div class="mt-auto w-100">
            <div class="row flex-nowrap">
              @if (product.current_price) {
                <div class="col align-self-center">
                  @if (!product.current_price.regular_amount) {
                    <div class="card-price">
                      @if (product.current_price.amount > 0 && product.type !== 4) {
                        {{ product.current_price.amount | currency: 'EUR' }}
                      } @else {
                        @if (product.current_price.amount > 0) {
                          <span>v.a. {{ product.current_price.amount | currency: 'EUR' }}</span>
                        } @else {
                          @if (product.current_price?.amount === 0) {
                            <span>{{ 'global.in_consultation' | transloco }}</span>
                          }
                        }
                      }
                    </div>
                  } @else {
                    <div class="card-price old-price">
                      {{ product.current_price.regular_amount | currency: 'EUR' }}
                    </div>
                    <div class="card-price new-price">
                      {{ product.current_price.amount | currency: 'EUR' }}
                    </div>
                  }
                </div>
              }
              <div class="col-auto ml-auto align-self-center">
                <a [routerLink]="['/bedrijf', shop.permalink, product.id]" class="btn btn-card">
                  {{ 'global.open' | transloco }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
